import React from 'react';
import { useTranslation } from 'react-i18next';
import { getCaptureStatCardTitle } from 'utils/get-capture-stat-card-title';
import { BaseCard } from './BaseCard';
import { CaptureStatCardProps } from './CardProps';
import {
  CAPTURE_STAT_CARD_CONFIG,
  CAPTURE_STAT_CARD_IDS,
} from './capture-stat-card-config';
import { DashboardMetricContent } from './DashboardMetricContent';

const isCaptureStatCard = (
  cardId: CaptureStatCardProps['cardId']
): cardId is (typeof CAPTURE_STAT_CARD_IDS)[number] =>
  CAPTURE_STAT_CARD_IDS.includes(cardId as (typeof CAPTURE_STAT_CARD_IDS)[number]);

export const CaptureStatCard: React.FC<CaptureStatCardProps> = ({
  cardId,
  captureDashboardStats,
  onClick,
}) => {
  const { t } = useTranslation();

  if (!isCaptureStatCard(cardId)) return null;

  const config = CAPTURE_STAT_CARD_CONFIG[cardId];
  if (!config) return null;

  const documentCount = captureDashboardStats?.[config.metricKey] ?? 0;
  const cardTitle = getCaptureStatCardTitle(cardId, t);

  return (
    <BaseCard cardId={cardId} title={null} onClick={onClick}>
      <DashboardMetricContent label={cardTitle} value={documentCount} />
    </BaseCard>
  );
};
